import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';

export const storyblokFooterResolver = (route: ActivatedRouteSnapshot) => {
  return inject(PICFLOW_STORYBLOK)
    .getStory('footers/website-footer', route)
    .pipe(map(resp => (resp && resp.story) || (false as const)));
};
